import * as React from 'react';
import { useLegacyPopoverContext } from './legacy-popover.context.js';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';
import { RenderComp } from '../../../react/components/core/render-comp.component.js';
import { composeEventHandlersUtil } from '../../../react/utilities/compose-event-handlers.util.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @deprecated use new `Popover` and its sub-components instead
 */ const LegacyPopoverLauncher = renderWithRef('PopoverLauncher', null, (props, ref)=>{
    const { onClick, children } = props;
    const { expanded, onRequestExpandedChange, launcherRef } = useLegacyPopoverContext();
    const classNames = [
        'swan-legacy-popover-launcher'
    ];
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        classNames: classNames,
        forwardedRef: launcherRef || ref,
        props: _object_spread_props(_object_spread({}, props), {
            onClick: composeEventHandlersUtil(onClick, ()=>{
                onRequestExpandedChange(!expanded);
            })
        })
    }, React.Children.map(children, (child, index)=>{
        if (index === 0 && /*#__PURE__*/ React.isValidElement(child)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return /*#__PURE__*/ React.cloneElement(child, {
                'aria-expanded': expanded || undefined
            });
        }
        return child;
    }));
});

export { LegacyPopoverLauncher };
